import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./UserTermsCheckbox.module.scss";

interface CustomCheckboxProps {
  icon: string;
  text: string;
  linkText?: string;
  linkHref?: string;
  containerClassName?: string;
  color?: string;
  onChange?: (checked: boolean) => void;
  error?: string;
  checked?: boolean;
  disabled?: boolean;
}

const UserTermsCheckbox = ({
  icon,
  text,
  linkText,
  linkHref,
  containerClassName = "",
  color = "",
  error,
  onChange,
  checked,
  disabled,
}: CustomCheckboxProps) => {
  const [isCheck, setIsCheck] = useState(false);

  const handleToggle = () => {
    if (disabled) return;
    const newValue = !isCheck;
    // setIsCheck(newValue);
    // onChange?.(newValue);
    onChange?.(!checked);
  };

  return (
   <div className={styles.checkBoxContainerAll}>
     <div
      className={`${styles.checkBoxContainer} ${containerClassName} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <div className={styles.checkBox}>
        <span
          style={{ borderColor: color }}
          className={styles.checkBoxImg}
          onClick={handleToggle}
        >
          {checked && <img src={icon} alt="CheckBox" />}
        </span>
      </div>
      <div className={styles.content}>
        <div>
          {linkHref && linkText && (
            <Link
              to={linkHref}
              target="_blank"
              className={styles.forgetPasswordBtn}
            >
              {linkText}
            </Link>
          )}
        </div>
        <p
          onClick={handleToggle}
          className={styles.checkBoxText}
          style={{ color: "#000000de" }}
        >
          {text}
        </p>
      </div>
    </div>
      <p className={styles.error_message}>{error}</p>
   </div>
  );
};

export default UserTermsCheckbox;
